__turbopack_context__.v({
  "GC": "styles-module-scss-module__gOWgja__GC",
  "SC": "styles-module-scss-module__gOWgja__SC",
  "disabled": "styles-module-scss-module__gOWgja__disabled",
  "navigationButton": "styles-module-scss-module__gOWgja__navigationButton",
  "root": "styles-module-scss-module__gOWgja__root",
});
